"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Loader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var Loader = function Loader(_ref) {
  var spinColor = _ref.spinColor,
      className = _ref.className,
      transparentCircle = _ref.transparentCircle,
      processText = _ref.processText,
      children = _ref.children,
      modalType = _ref.modalType,
      modalMode = _ref.modalMode,
      _onClick = _ref.onClick,
      onKeyPress = _ref.onKeyPress,
      mask = _ref.mask,
      style = _ref.style;

  function getLoaderContent() {
    var loaderStyle = spinColor ? {
      borderTopColor: "".concat(spinColor)
    } : null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "shpmtc-loader ".concat(className),
      style: style
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "\n            shpmtc-loader__spin \n            ".concat(transparentCircle === true ? 'shpmtc-loader__spin--transparent-circle' : '', "\n          "),
      style: loaderStyle
    }), processText ? /*#__PURE__*/_react.default.createElement("span", {
      className: "shpmtc-loader__text"
    }, processText) : null, children);
  }

  var modalTypeStyle = '';

  switch (modalType) {
    case 'light':
      modalTypeStyle = 'shpmtc-loader-modal--light-modal';
      break;

    case 'transparent':
      modalTypeStyle = 'shpmtc-loader-modal--transparent-modal';
      break;

    default:
      break;
  }

  return modalMode === true ? /*#__PURE__*/_react.default.createElement("div", {
    className: "\n          shpmtc-loader-modal\n          ".concat(modalTypeStyle, "\n          ").concat(mask ? 'shpmtc-loader-modal--mask' : '', "\n        "),
    onClick: function onClick() {
      _onClick();
    },
    onKeyPress: onKeyPress
  }, getLoaderContent()) : getLoaderContent();
}; // // Prop Types


exports.Loader = Loader;
Loader.defaultProps = {
  style: null,
  className: '',
  children: null,
  processText: null,
  spinColor: null,
  transparentCircle: null,
  modalMode: false,
  modalType: null,
  mask: null,
  onClick: null,
  onKeyPress: null
};
Loader.propTypes = {
  style: _propTypes.default.instanceOf(Object),
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  processText: _propTypes.default.string,
  spinColor: _propTypes.default.string,
  transparentCircle: _propTypes.default.bool,
  modalMode: _propTypes.default.bool,
  modalType: _propTypes.default.string,
  mask: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onKeyPress: _propTypes.default.func
};
var _default = Loader;
exports.default = _default;